// pages/PasswordRecovery/ForcedResetOtpPage.tsx
import { OTPInput, Button } from 'shared-portal-components-v2';

import { useRecoveryEmailOtp } from '@/hooks/auth/useRecoveryEmailOtp';
import { OTP_LENGTH } from '@/constants';

/**
 * Shown after a sign-in attempt on an account whose credentials an administrator
 * has force-reset. Reuses the recovery email-OTP hook (same 6-digit code, same
 * verify → 2FA → set-password steps as forgot-password) but with copy explaining
 * why the user is here.
 */
export default function ForcedResetOtpPage() {
  const { state, handlers } = useRecoveryEmailOtp();

  return (
    <div className="w-full max-w-md flex flex-col gap-8">
      <div className="text-center flex flex-col gap-2">
        <h1 className="text-3xl font-bold text-foreground">Password reset required</h1>
        <p className="text-muted-foreground text-lg">
          An administrator has reset your login credentials. Enter the {OTP_LENGTH}-digit code we
          emailed you to verify it's you, then set a new password.
        </p>

        {state.globalError !== null && (
          <div className="rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm text-destructive">
            {state.globalError}
          </div>
        )}
      </div>

      <form onSubmit={handlers.handleSubmit} className="flex flex-col gap-6">
        <div className="flex justify-center">
          <OTPInput
            value={state.otp}
            onChange={handlers.handleOtpChange}
            numInputs={OTP_LENGTH}
            hasAutoFocus
            isDisabled={state.isLoading}
            inputClassName=""
            containerClassName="justify-center gap-3"
          />
        </div>

        <div className="flex flex-col gap-3">
          <Button
            type="submit"
            variant="primary"
            size="lg"
            className="w-full h-12 text-base font-semibold"
            isLoading={state.isLoading}
            disabled={state.isLoading || state.otp.length !== OTP_LENGTH}
          >
            Verify
          </Button>

          <div className="flex justify-end text-sm">
            <Button
              type="button"
              variant="link"
              className="p-0 h-auto text-accent hover:text-accent/80"
              onClick={handlers.handleResend}
              disabled={state.isLoading}
            >
              Didn't receive the code? Resend
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
